import SimpleTree, { toggleExpandedForAll } from "./SimpleTree";
export default SimpleTree;
export { toggleExpandedForAll };
